export type DressageProtocolCategory = 'INDIVIDUAL' | 'GROUP' | 'YOUNG' | 'EVENTING';

export const getCategoryLabel = (type: DressageProtocolCategory) => {
  switch (type) {
    case "INDIVIDUAL":
      return "Individueel";
    case "GROUP":
      return "Groepsdressuur";
    case "EVENTING":
      return "Eventing";
    case "YOUNG":
      return "Jonge Paarden";
    default:
      return type;
  }
};
